import { useTranslation } from 'react-i18next';
import type { Participant } from '@/types/evaluation.types';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

interface RemoveParticipantDialogProps {
  participant: Participant | null;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function RemoveParticipantDialog({
  participant,
  isOpen,
  onClose,
  onConfirm,
}: RemoveParticipantDialogProps) {
  const { t } = useTranslation(['participants', 'common']);

  if (!participant) return null;

  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('participants:removeDialog.title')}</AlertDialogTitle>
          <AlertDialogDescription>
            {t('participants:removeDialog.description', { name: participant.name })}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t('participants:removeDialog.cancel')}</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {t('participants:removeDialog.confirm')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
